export const DOLLAR_AMOUNT_LABEL = "Dollar Amount";
export const SALARY_MULTIPLIER_LABEL = "Salary Multiplier";
